export default __webpack_public_path__ + "static/media/survey-music.53bec3ff.png";